import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
  Box,
  Typography,
  Divider,
  Card,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";
import { IOSSwitch } from "./IOSSwitch";
import { Association, Vehicle } from "../../../types/api";
import { driverDrawer } from "../style";
import { fleetService } from "../../../api/fleetService/fleetServicesRegistered";
import { useBusinessProfile } from "../../../utils/hooks/useBusinessProfile";
import { useAuth } from "../../../utils/hooks/useAuth";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import CustomDatePicker from "../../../components/sidebarAddVehicle/CustomDatePicker";
import { formatDateIgnoreTimezone } from "../../../utils/DateUtils";

dayjs.extend(utc);
interface AddAssociationDialogProps {
  open: boolean;
  onClose: () => void;
  vehicleGridData: Vehicle[];
  selectedAssociations?: Association[];
  onInsert: (associations: Association[]) => void;
  onUpdate: (associations: Association[]) => void;
  driver: any;
}

const AddAssociationDialog: React.FC<AddAssociationDialogProps> = ({
  open,
  onClose,
  vehicleGridData,
  selectedAssociations,
  onInsert,
  onUpdate,
  driver,
}) => {

  //INIT DATI
  const { t } = useTranslation();
  const { businessProfile } = useBusinessProfile();
  const { user } = useAuth();
  const [associations, setAssociations] = useState<Association[]>([]);
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);



  //Gestione errori
  const [error, setError] = useState<string | null>(null);
  const [dateErrors, setDateErrors] = useState<Record<number, string>>({});
  const [plateErrors, setPlateErrors] = useState<Record<number, string>>({});
  const [touchedFields, setTouchedFields] = useState<Record<number, boolean>>(
    {}
  );
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  /*  function getLocalDateWithTimezone(selectedDate: any) {
     const date = new Date(selectedDate);
   
     // Ottiene l'offset in minuti e lo converte in ore
     const offsetMinutes = date.getTimezoneOffset();
     const offsetHours = Math.abs(offsetMinutes / 60);
     const offsetSign = offsetMinutes > 0 ? "-" : "+"; // Se è positivo significa che siamo a ovest di UTC
   
     // Formatta l'offset in formato +HH:00 o -HH:00
     const offsetFormatted = `${offsetSign}${String(offsetHours).padStart(2, "0")}:00`;
     const localDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}T${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}${offsetFormatted}`;
  
     return localDate;
    
   } */




  // Funzione per gestire l'errore di inserimento dell'associazione
  const ErrorMessageList = ({ failedList }: { failedList: any[] }) => (
    <ul>
      {failedList.map((failedItem: any, index: number) => {
        const licensePlate = failedItem.licensePlate;
        const dateFrom = dayjs.utc(failedItem.dateFrom).format("DD/MM/YYYY");
        const dateTo = failedItem.dateTo
          ? dayjs.utc(failedItem.dateTo).format("DD/MM/YYYY")
          : "-";
        const parsedDateFrom = failedItem.dateFrom
          ? new Date(failedItem.dateFrom.replace("T", " "))
            .toLocaleString(undefined, {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              hour12: false, // Usa il formato 24 ore
            })
            .replace(",", "") // Rimuove la virgola tra data e ora
          : "-";

        const parsedDateTo = failedItem.dateTo
          ? new Date(failedItem.dateTo.replace("T", " "))
            .toLocaleString(undefined, {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            })
            .replace(",", "") // Rimuove la virgola tra data e ora
          : "-";
        return (
          <li key={index} style={{ width: "430px", marginTop: "8px" }}>
            <strong>Targa:</strong> {licensePlate} <strong>Dal:</strong>{" "}
            {parsedDateFrom}{" "}
            {parsedDateTo && (
              <>
                <strong>Al:</strong> {parsedDateTo}
              </>
            )}
            <br />
          </li>
        );
      })}
    </ul>
  );
  // Funzione per gestire l'errore di inserimento dell'associazione
  const handleAssociationError = (error: any) => {
    if (
      error.response &&
      error.response.data &&
      error.response.data.failedList
    ) {
      const failedList = error.response.data.failedList;

      // Mostra il toast con il componente React
      toast.error(
        <>
          <strong>
            Errore durante l'inserimento delle seguenti associazioni:<br></br>
          </strong>
          <ErrorMessageList failedList={failedList} />
        </>
      );
    } else {
      toast.error("Errore durante l'inserimento dell'associazione");
    }
  };
  const normalizeDate = (date: Date) => {
    const newDate = new Date(date);
    newDate.setSeconds(0, 0); // ⏳ Rimuove secondi e millisecondi
    return newDate;
  };

  const validateAllAssociations = (updatedAssociations: Association[]) => {
    const newDateErrors: Record<number, string> = {};
    const newPlateErrors: Record<number, string> = {};

    updatedAssociations.forEach((association, index) => {
      const { dateFrom, dateTo, vehicleLicensePlate } = association;
      /* 
            if ((!vehicleLicensePlate|| vehicleLicensePlate.trim() === " ")&& !touchedFields) {
              newPlateErrors[index] = "La targa è obbligatoria.";
            }
            if (!dateFrom && !touchedFields) {
              newDateErrors[index] = "La data di inizio è obbligatoria.";
              return;
            }
                const normalizedDateFrom = normalizeDate(new Date(dateFrom));
            */


      if ((!vehicleLicensePlate || vehicleLicensePlate.trim() === " ") && !touchedFields) {
        newPlateErrors[index] = "La targa è obbligatoria.";
      }
      if (!dateFrom && !touchedFields) {
        newDateErrors[index] = "La data di inizio è obbligatoria.";
        return;
      }

      const normalizedDateFrom = normalizeDate(new Date(dateFrom!));
      const normalizedDateTo = dateTo
        ? normalizeDate(new Date(dateTo))
        : normalizeDate(new Date("2200-12-31T23:59"));

      if (normalizedDateTo.getTime() < normalizedDateFrom.getTime()) {
        newDateErrors[index] =
          "La data di fine non può essere precedente alla data di inizio.";
        return;
      }

      // 🚨 Controllo sovrapposizioni con tutte le altre associazioni
      const hasOverlap = updatedAssociations.some((other, otherIndex) => {
        if (otherIndex === index) return false;

        const otherDateFrom = other.dateFrom
          ? normalizeDate(new Date(other.dateFrom))
          : null;
        const otherDateTo = other.dateTo
          ? normalizeDate(new Date(other.dateTo))
          : normalizeDate(new Date("2200-12-31T23:59"));

        if (!otherDateFrom) return false;

        return (
          normalizedDateFrom.getTime() < otherDateTo.getTime() &&
          otherDateFrom.getTime() < normalizedDateTo.getTime()
        );
      });

      if (hasOverlap) {
        newDateErrors[index] =
          "Le date si sovrappongono con un'altra associazione.";
      }
    });

    setDateErrors(newDateErrors);
    setPlateErrors(newPlateErrors)
  };

  //FUNZIONI PER CHIAMATE API
  const handleInsertAssociation = async () => {
    if (!businessProfile) return;
    const legacyCodes = {
      legacyCode: businessProfile.legacycodes[0].legacycode,
      company: businessProfile.legacycodes[0].company,
    };

    const associationsWithLegacyCodes = associations.map((association) => ({
      legacyCodes,
      vehicleLicensePlate: association.vehicleLicensePlate,
      phone: driver.phone,
      dateFrom: association.dateFrom ?? "", // ✅ Mantiene il fuso locale
      dateTo: association.dateTo
        ? association.dateTo
        : null,
      editUser: user?.email || "-",
      status: (association.status as "ACTIVE") || "CANCELLED",
    }));

    try {
      // Chiamata alla funzione del service
      const response = await fleetService.insertDriverVehicleAssociation(
        associationsWithLegacyCodes
      );
      //setResult(response);
      return response;
    } catch (err: any) {
      handleAssociationError(err);

      //setError("Si è verificato un errore durante l'inserimento.");
      return null;
    }
  };

  const handleUpdateAssociation = async () => {
    const findAssociationById = associations.find(
      (association) =>
        association.id === (selectedAssociations && selectedAssociations[0].id)
    );
    const payloadUpdateAssociation = {
      id: Number(findAssociationById && findAssociationById.id),
      newDateFrom: (findAssociationById && findAssociationById.dateFrom) ?? "",
      newDateTo:
        (findAssociationById && findAssociationById.dateTo) ?? undefined,
      newEditUser: user?.email || "-",
    };

    try {
      // Chiamata alla funzione del service
      const response = await fleetService.updateDriverVehicleAssociation(
        payloadUpdateAssociation
      );
      if (!response)
        return

      // Aggiorna le date nelle associazioni
      const updatedAssociations = associations.map(assoc => ({
        ...assoc,
        dateFrom: assoc.dateFrom,
        dateTo: assoc.dateTo,
      }));
      //setResult(response);
      onUpdate(updatedAssociations)

      toast.success("Associazione aggiornata correttamente");
      return response;
    } catch (err: any) {
      handleAssociationError(err);

      //setError("Si è verificato un errore durante l'inserimento.");
      return null;
    }
  };
  const handleAddAssociation = () => {
    setAssociations([
      ...associations,
      {
        vehicleLicensePlate: "",
        vehicleSubType: "",
        vehicleType: "TRACTOR",
        dateFrom: null,
        dateTo: null,
        status: "ACTIVE",
        lastAssociationUpdate: new Date().toISOString(),
      },
    ]);
  };

  const handleRemoveAssociation = (index: number) => {
    setAssociations(associations.filter((_, i) => i !== index));


  };
  const handleClick = async () => {
    setSubmitLoader(true);
    setPlateErrors({}); // Pulisce gli errori delle targhe
    setDateErrors({});   // Pulisce gli errori delle date

    // ✅ Stati per gli errori separati
    const newPlateErrors: Record<number, string> = {};
    const newDateErrors: Record<number, string> = {};
    // ✅ Validazione delle associazioni
    const hasError = associations.some((association, index) => {
      const { vehicleLicensePlate, dateFrom, dateTo } = association;

      let hasLocalError = false;

      // 🚨 Controllo sulla targa
      if (!vehicleLicensePlate || vehicleLicensePlate.trim() === " ") {
        newPlateErrors[index] = "La targa è obbligatoria.";
        hasLocalError = true;
      }

      // 🚨 Controllo sulle date
      if (!dateFrom) {
        newDateErrors[index] = "La data di inizio è obbligatoria.";
        hasLocalError = true;
      } else {
        const normalizedDateFrom = new Date(dateFrom);
        const normalizedDateTo = dateTo ? new Date(dateTo) : new Date("2200-12-31");

        // Verifica che dateTo non sia precedente a dateFrom
        if (normalizedDateTo.getTime() < normalizedDateFrom.getTime()) {
          newDateErrors[index] = "La data di fine non può essere precedente alla data di inizio.";
          hasLocalError = true;
        }
      }

      return hasLocalError; // Restituisce true se ci sono errori in questa associazione
    });

    setPlateErrors(newPlateErrors); // ✅ Aggiorna gli errori sulle targhe
    setDateErrors(newDateErrors);   // ✅ Aggiorna gli errori sulle date

    if (hasError) {
      console.warn("Errore: alcuni campi obbligatori sono vuoti o errati.");
      setSubmitLoader(false);
      return; // ⛔ Blocca il submit se ci sono errori
    }

    try {
      const response = await handleInsertAssociation();

      if (response?.successList) {
        const updatedAssociations = associations
          .filter((association) =>
            response.successList.some((item) =>
              item.licensePlate === association.vehicleLicensePlate &&
              formatDateIgnoreTimezone(item.dateFrom) === formatDateIgnoreTimezone(association.dateFrom) &&
              formatDateIgnoreTimezone(item.dateTo) === formatDateIgnoreTimezone(association.dateTo)
            )
          )
          .map((association) => {
            const matchingItem = response.successList.find(
              (item) =>
                item.licensePlate === association.vehicleLicensePlate &&
                formatDateIgnoreTimezone(item.dateFrom) === formatDateIgnoreTimezone(association.dateFrom) &&
                formatDateIgnoreTimezone(item.dateTo) === formatDateIgnoreTimezone(association.dateTo)
            );
            return matchingItem ? { ...association, id: matchingItem.id } : association;
          });


        setAssociations(updatedAssociations); // ✅ Aggiorna lo stato locale solo con le associazioni valide
        onInsert(updatedAssociations); // ✅ Notifica il genitore solo con i dati validi

        if (updatedAssociations.length > 0) {
          toast.success(<ErrorMessageList failedList={response.successList} />, {
            position: "bottom-left",
            autoClose: 3000,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }

        if (response.failedList.length > 0) {
          toast.error(<ErrorMessageList failedList={response.failedList} />, {
            position: "bottom-left",
            autoClose: 5000,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      }
    } catch (error) {
      console.error("Errore durante l'inserimento delle associazioni:", error);
    } finally {
      setSubmitLoader(false);
    }

    handleClose(); // Chiude il dialog/modal
  };


  const handleClose = () => {
    setError(null);
    setDateErrors({});
    setPlateErrors({});
    setTouchedFields({});
    onClose();
  };

  const handleChange = (index: number, field: keyof Association, value: string | Date | null) => {
    setAssociations((prevAssociations) => {
      const updatedAssociations = prevAssociations.map((assoc, i) => {
        if (i === index) {
          let updatedAssoc = { ...assoc, [field]: value };

          // Se cambia la targa, aggiorna anche il tipo di veicolo
          if (field === "vehicleLicensePlate") {
            const selectedVehicle = vehicleGridData.find(vehicle => vehicle.licensePlate === value);
            updatedAssoc = {
              ...updatedAssoc,
              vehicleType: selectedVehicle?.mainCategory || "",
              vehicleSubType: selectedVehicle?.category || "",
            };

            // Rimuovi eventuali errori sulla targa
            setPlateErrors((prevErrors) => {
              const newErrors = { ...prevErrors };
              delete newErrors[index];
              return newErrors;
            });
          }

          // Validazione del tempo se la data è oggi
          if ((field === "dateFrom" || field === "dateTo") && value) {
            try {
              const selectedDate = new Date(value);
              const now = new Date();
              
              // Verifica che la data sia valida
              if (!isNaN(selectedDate.getTime())) {
                // Verifica se la data selezionata è oggi
                const isToday = selectedDate.getDate() === now.getDate() && 
                              selectedDate.getMonth() === now.getMonth() && 
                              selectedDate.getFullYear() === now.getFullYear();
                
                if (isToday) {
                  // Se l'ora selezionata è minore dell'ora attuale, imposta l'ora attuale
                  if (selectedDate.getHours() < now.getHours() || 
                      (selectedDate.getHours() === now.getHours() && selectedDate.getMinutes() < now.getMinutes())) {
                    selectedDate.setHours(now.getHours());
                    selectedDate.setMinutes(now.getMinutes());
                    updatedAssoc = { ...updatedAssoc, [field]: selectedDate };
                  }
                }
              }
            } catch (error) {
              console.error('Error processing date:', error);
            }
          }

          return updatedAssoc;
        }
        return assoc;
      });

      setTouchedFields((prev) => ({ ...prev, [index]: true }));
      validateAllAssociations(updatedAssociations);
      return updatedAssociations;
    });
  };




  useEffect(() => {
    if (open) {
      setAssociations(
        selectedAssociations && selectedAssociations.length > 0
          ? selectedAssociations
          : [
            {
              vehicleLicensePlate: "",
              vehicleSubType: "",
              vehicleType: "TRACTOR",
              dateFrom: null,
              dateTo: null,
              status: "ACTIVE",
              lastAssociationUpdate: new Date().toISOString(),
            },
          ]
      );
    }
  }, [open]);




  useEffect(() => {
    if (open && associations) {
      validateAllAssociations(associations);
    }
  }, [open, associations])
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: "600",
          }}
        >
          {selectedAssociations && selectedAssociations[0].vehicleLicensePlate
            ? t("common.sidebars.addAssociations.modifyAssociation")
            : t("common.sidebars.addAssociations.newAssociation")}
        </Typography>
      </DialogTitle>
      <Divider />
      {error && (
        <Card
          elevation={1}
          square
          sx={{ width: "100%", textAlign: "center", padding: "8px" }}
        >
          <Typography
            color="error"
            sx={{ fontWeight: "bold", fontSize: "14px" }}
          >
            {error}
          </Typography>
        </Card>
      )}
      <DialogContent sx={{ height: "830px" }}>
        {associations.map((assoc, index) => {
          const isError = dateErrors[index] || false;
          const isErrorPlate = plateErrors[index] || false;
          return (
            <Box key={index} sx={{ display: "flex", flexDirection: "column" }}>
              {/* Select con le targhe dei veicoli */}
              <Box>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "14px",
                    color: "#CF0A2C",
                    marginBottom: "4px",
                    marginTop: "16px",
                  }}
                >
                  {t("common.sidebars.addAssociations.plate")} *
                </Typography>
                <Autocomplete
                  key={`${assoc.vehicleLicensePlate}-${index}`}
                  value={associations[index]?.vehicleLicensePlate || ""}
                  onChange={(event, newValue) =>
                    handleChange(index, "vehicleLicensePlate", newValue)
                  }
                  disabled={
                    selectedAssociations &&
                      selectedAssociations[0].vehicleLicensePlate
                      ? true
                      : false
                  }
                  options={vehicleGridData
                    .filter(vehicle => vehicle.environmentClass && vehicle.fuelType)
                    .map(vehicle => vehicle.licensePlate)
                  }
                  getOptionLabel={(option) => option || ""}
                  isOptionEqualToValue={(option, value) => option === value}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={
                        t("common.sidebars.addAssociations.insertPlate") || ""
                      }
                      fullWidth
                      sx={driverDrawer.autocompleteComponent}
                      disabled={
                        selectedAssociations &&
                          selectedAssociations[0].vehicleLicensePlate
                          ? true
                          : false
                      }
                      error={!!plateErrors[index]}
                      helperText={
                        plateErrors[index]
                          ? t("common.errors.mandatoryField")
                          : ""
                      }
                    />
                  )}
                />
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "14px",
                    color: "#CF0A2C",
                    marginBottom: "4px",
                    marginTop: "16px",
                  }}
                >
                  {t("common.sidebars.addAssociations.vehicle")}
                </Typography>
                <TextField
                  // value={`${assoc.vehicleType} ${assoc.vehicleSubType}`}
                  value={assoc.vehicleSubType ? t(`screens.fleetAndRoute.vehicles.${assoc.vehicleSubType}`) : ""}
                  //  value={`${assoc.vehicleSubType}`}
                  disabled
                  fullWidth
                  sx={driverDrawer.textField}
                />
              </Box>
              {isError && (
                <Divider
                  sx={{
                    height: "2px",
                    marginTop: "16px",
                    marginBottom: "4px",
                    backgroundColor: "#CF0A2C",
                  }}
                />
              )}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: "8px",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      fontSize: "14px",
                      color: "#CF0A2C",
                      marginBottom: "4px",
                      marginTop: !isError ? "16px" : "",
                    }}
                  >
                    {t("common.sidebars.addAssociations.startDate")} *
                  </Typography>
                  <CustomDatePicker
                    date={assoc.dateFrom}
                    onChange={(date) => handleChange(index, "dateFrom", date)}
                    error={touchedFields[index] && !!dateErrors[index]}
                    maxDate={assoc.dateTo ? new Date(assoc.dateTo) : undefined}
                    minDate={new Date()}
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      fontSize: "14px",
                      color: "#CF0A2C",
                      marginBottom: "4px",
                      marginTop: !isError ? "16px" : "",
                    }}
                  >
                    {t("common.sidebars.addAssociations.endDate")}
                  </Typography>
                  <CustomDatePicker
                    date={assoc.dateTo}
                    onChange={(date) => handleChange(index, "dateTo", date)}
                    error={false}
                    minDate={assoc.dateFrom ? new Date(assoc.dateFrom) : new Date()}
                  />
                </Box>
              </Box>
              {isError && (
                <Divider
                  sx={{
                    height: "2px",
                    marginTop: "12px",
                    backgroundColor: "#CF0A2C",
                  }}
                />
              )}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: "8px",
                  alignItems: "center",
                  marginTop: "16px",
                }}
              >
                {!selectedAssociations?.[0]?.vehicleLicensePlate && (
                  <>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        fontSize: "14px",
                        color: "#CF0A2C",
                      }}
                    >
                      {t("common.sidebars.addAssociations.vehicleAssociation")}:
                    </Typography>
                    <IOSSwitch
                      checked={assoc.status === "ACTIVE"}
                      onChange={(e) => {
                        const newStatus = e.target.checked ? "ACTIVE" : "CANCELLED";

                        setAssociations((prevAssociations) => {
                          const updatedAssociations = prevAssociations.map(
                            (item, i) =>
                              i === index ? { ...item, status: newStatus } : item
                          );
                          return updatedAssociations;
                        });
                      }}
                    />
                  </>
                )}
              </Box>
              {index !== 0 && (
                <IconButton
                  onClick={() => handleRemoveAssociation(index)}
                  color="error"
                  sx={{ marginTop: "8px", alignSelf: "flex-end" }}
                >
                  <Delete />
                </IconButton>
              )}
              <Divider sx={{ margin: "16px 0" }} />
            </Box>
          );
        })}

        {!selectedAssociations?.[0]?.vehicleLicensePlate && (
          <Button
            startIcon={<Add />}
            onClick={handleAddAssociation}
            sx={{
              color: "#CF0A2C",
              textDecoration: "underline",
              fontWeight: "600",
            }}
          >
            {t("common.sidebars.addAssociations.addNew")}
          </Button>
        )}
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          onClick={handleClose}
          variant="outlined"
          sx={{ color: "#333333", borderColor: "#333333" }}
        >
          {t("common.sidebars.addAssociations.cancel")}
        </Button>
        {selectedAssociations &&
          selectedAssociations?.[0].vehicleLicensePlate ? (
          <Button
            onClick={() => {
              handleUpdateAssociation();
            }}
            sx={{ backgroundColor: "#CF0A2C" }}
            variant="contained"
            disabled={!(Object.keys(dateErrors).length === 0 && Object.keys(plateErrors).length === 0)}

          >
            {t("common.sidebars.addAssociations.save")}
          </Button>
        ) : (
          <Button
            onClick={handleClick}
            sx={{ backgroundColor: "#CF0A2C" }}
            variant="contained"
            disabled={!(Object.keys(dateErrors).length === 0 && Object.keys(plateErrors).length === 0)}

          >
            {submitLoader ? <CircularProgress size={24} sx={{ color: 'white' }} /> : t("common.sidebars.addAssociations.save")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AddAssociationDialog;
